/**
 * @module upper/url/1_0
 * @author sinchen <sinchen@lexinfintech.com>
 * @version 1.0
 * @description url相关操作方法组件
 */
import M_URL_HANDLER from '~url_handler@1.0'
import M_REQUEST_FACTORY from '~request@1.0'

let GLOBAL_REQUEST = M_REQUEST_FACTORY()

let Url = {
    /**
     * @function isUrl
     * @description 是否为正确的链接 [逻辑收拢common]
     * @param {String} url 链接
     * @returns {Boolean} 返回true或false
     * @instance
     * @example
     * M_URL.isUrl('https://xxx.com') // true
     */
    isUrl: function (url) {
        return M_URL_HANDLER.isUrl(url)
    },

    /**
     * @function getUrlParam
     * @description 获取url参数，兼容vue-router参数，会一起获取
     * @param {String} [url] 链接 可选 不传则使用当前链接
     * @param {String} [name] 要获取的参数名称，可选，如果不传则返回全部
     * @return {Object|String} 返回链接参数对象
     * @instance
     * @example
     * M_URL.getUrlParam('http://xxx.com?a=1&b=1') // {a: 1, b: 2}
     * M_URL.getUrlParam('http://xxx.com?a=1&b=1', 'a') // 1
     * M_URL.getUrlParam('a') // 假设当前链接有参数a且值为1，则返回1
     */
    getUrlParam: function (url, name) {
        let parse_url = '' // 要解析的url
        let parse_name = '' // 要解析的参数key值
        let params = {} // 解析后的对象
        let reg = /[?&]([^?&=]+)=([^&#]+)/g // 正则
        let matcher = {}

        if (!name && !url) {
            // 两个参数都没有传，取当前页面链接作为要解析的链接
            parse_url = location.href
        } else if (!name) {
            // 没有传url，判断第一个参数有没有协议，以区分传的是url还是name
            if (this.isUrl(url)) {
                parse_url = url
            } else {
                parse_url = location.href
                parse_name = url
            }
        } else {
            // 两者都有传
            parse_url = url
            parse_name = name
        }

        matcher = reg.exec(parse_url) // 解析链接
        // 若不为null，则进行赋值，继续匹配
        while (matcher !== null) {
            params[matcher[1]] = decodeURIComponent(matcher[2])
            matcher = reg.exec(parse_url)
        }

        // 指定了某个参数，则返回相应的值。否则返回全部参数
        if (parse_name && typeof parse_name === 'string') {
            return params[name] || ''
        } else {
            return params
        }
    },
    /**
     * 图片显示路径。若是相对链接，则发请求获取完整链接。
     * @param {String} pic 图片链接
     * @param {String} upload_domain 上传域名
     * @return {String} 返回绝对路径图片链接
     */
    async getUploadUrl (pic, upload_domain) {
        if (!pic) {
            return ''
        }

        if (this.isUrl(pic)) { // 完整路径则直接返回
            return pic
        } else { // 否则发起请求 获取完整链接
            return GLOBAL_REQUEST.ajax({
                url: `https://${upload_domain || 'oss-fit-upload.oa.fenqile.com'}/getUrl?output_type=json`,
                data: {
                    protocol: 'https',
                    urlPath: pic
                }
            }).then((res) => {
                if (+res.retcode == 0) {
                    return res.url
                }
            }).catch(err => {
                console.log(err)
            })
        }
    },

    /**
     * @function urlConcat
     * @description 生成拼接的URL链接
     * @param {String} href 指定链接[必选]
     * @param {Obj} params  指定URL后面参数，可靠默认为当前URL[可选]
     * @return {String} 返回拼接完成的url
     * @instance
     * @example
     * M_URL.urlConcat('www.fenqile.com', {'a': 'b', 'c': 'd'});
     * return www.fenqile.com?a=b&c=d
     */
    urlConcat: function (href, params) {
        return M_URL_HANDLER.joinParams(href, params) // 逻辑收拢至quark common
    }
}

export default Url
